@if (changeHistory) {
  @if (changeHistory.system) {
    <img class="img-fluid" [src]="DEFAULT_LOGO_URL" [alt]="CIM_COMPANY_NAME"/>
  } @else if (changeHistory?.author_id) {
    <app-show-user-entity-logo [entity]="changeHistory?.author?.entity" [fontSize]="fontSize"/>
  } @else {
    <app-single-letter-icon [text]="'?'" [title]="''"/>
  }
}
